import React, { useState } from "react";
import { Button } from "../../components/ui";
import { Link } from "react-router-dom";
import { DownloadIcon } from "@heroicons/react/solid";
import useGet from "../../hooks/read/useGet";
import toast from "react-hot-toast";
import MarkWFHAttendance from "./MarkWFHAttendance";

const UserPunches = ({ data }) => {
  // Code to check if user has punched in for the day
  const [hasPunchedIn, setHasPunchedIn] = useState(false);
  const { list: getStatusReq } = useGet({
    url: "punch_status",
    onSuccess: (res) => {
      setHasPunchedIn(res?.is_logged_in);
      // setHasPunchedIn(true);
    },
  });
  console.log(getStatusReq?.data);

  const {
    list: punchList,
    paramsObject,
    setGetListParams,
  } = useGet({
    url: "fetch_users_wfh_data",
    // initialData: initialEmployeeState,
    onSuccess: () => {
      // scrollToTop()
      // toast.success('Employees Fetched Successfully')
    },
    onError: () => {
      toast.error(
        "There Was An Error While Fetching The Data Please Try Again Later"
      );
    },
  });
  return (
    <>
      <p className="text-xl font-semibold text-primary pb-5">
        {getStatusReq?.data?.is_logged_in ? (
          <p> Status : Logged In</p>
        ) : (
          <p> Status : Not Logged In</p>
        )}
      </p>
      {getStatusReq?.data?.is_wfh && getStatusReq?.data?.is_logged_in ? (
        <MarkWFHAttendance />
      ) : (
        <>
          {getStatusReq?.data?.is_logged_in ? (
            <div className="flex items-center space-x-7">
              <Link to={`/attendance-punch-in`}>
                <Button variant="outline"> Mark visit </Button>
              </Link>

              <Link to={`/punchout`}>
                <Button> Punch Out </Button>
              </Link>
              <Link to={`/attendance-punch-in/logs`}>
                <Button>View Punch-in Logs</Button>
              </Link>
            </div>
          ) : (
            <div className="grid grid-cols-2 lg:grid-cols-4 gap-x-4">
              <Link to={`/attendance-punch-in`}>
                <Button>Punch Attendance</Button>
              </Link>
              <Link to={`/attendance-punch-in/logs`}>
                <Button>View Punch-in Logs</Button>
              </Link>
            </div>
          )}
        </>
      )}
      <div>
        <div className="my-4 space-x-4">
          {data?.appointment_letter && (
            <a
              className="text-lg font-semibold p-5 bg-orange-700 text-white text-center inline-block rounded"
              href={data?.appointment_letter}
              download={true}
            >
              <DownloadIcon className="w-6 h-6 inline-block" />{" "}
              <span className="inline-block">Appointment Letter</span>
            </a>
          )}
          {data?.confirmation_letter && (
            <a
              className="text-lg font-semibold p-5 bg-orange-700 text-white text-center inline-block rounded"
              href={data?.confirmation_letter}
              download={true}
            >
              <DownloadIcon className="w-6 h-6 inline-block" />{" "}
              <span className="inline-block">Confirmation Letter</span>
            </a>
          )}
        </div>
      </div>
    </>
  );
};

export default UserPunches;
